"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confDropdownClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var confDropdownClick = function (event) {
    var eventData = {
        action: 'dropdown-click',
        event: analytics_layer_1.LinkInteractionEventNames.ConfDropdownClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.ConfDropdownClick,
        conf: {
            confName: event.eventData.conf.confName || consts_1.NOT_AVAILABLE,
            confCat: event.eventData.conf.confCat || consts_1.NOT_AVAILABLE,
            confClick: event.eventData.conf.confClick || consts_1.NOT_AVAILABLE,
            confTags: event.eventData.conf.confTags || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.confDropdownClick = confDropdownClick;
